// DunDial footer — Privacy + Terms links + copyright.
//
// Rendered inside DashboardPage rather than via AppShell so it stays
// product-specific. When more products need the same shape, the kit
// can grow an AppShell `footer` slot to consolidate.
export function Footer() {
  return (
    <footer className="mt-12 border-t border-border/60 pt-5">
      <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
        <a
          href="/privacy"
          className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground/60 transition-colors hover:text-muted-foreground"
        >
          Privacy
        </a>
        <a
          href="/terms"
          className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground/60 transition-colors hover:text-muted-foreground"
        >
          Terms
        </a>
        <span className="ml-auto font-mono text-[10px] uppercase tracking-widest text-muted-foreground/40">
          DunDial · AV Agency
        </span>
      </div>
    </footer>
  );
}
